import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";

import { useAppSelector } from "../../../../app/hooks";
import { DumpsterLocationHistory, dumpsterEventTypeToText } from "../../../../models";

import "./DumpsterHistoryCard.scss";

export function DumpsterHistoryCard() {
  const locationHistory = useAppSelector((state) => state.dumpsters.locationHistory);
  const getLocationHistoryAPI = useAppSelector(
    (state) => state.dumpsters.getDumpsterLocationHistory
  );

  const formatAddress = (address: string, city: string, zip: string) => {
    const parts = [address, city, zip].filter(Boolean);
    return parts.length > 0 ? parts.join(", ") : "-";
  };

  const getLocationType = (entry: DumpsterLocationHistory): "order" | "storage" | "unknown" => {
    if (entry.orderId) return "order";
    if (entry.storageYardId) return "storage";
    return "unknown";
  };

  const locationTypeLabels: Record<string, string> = {
    order: "Order",
    storage: "Storage",
    on_truck: "On Truck",
    unknown: "Unknown",
  };

  return (
    <div className="dumpster-history-card-component">
      <div className="header">
        <div className="header-title">Location History</div>
      </div>

      {getLocationHistoryAPI.loading ? (
        <div className="loading-container">Loading history...</div>
      ) : locationHistory.length === 0 ? (
        <div className="empty-state">
          <p>No location history available</p>
        </div>
      ) : (
        <div className="table-container">
          <table className="history-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Event</th>
                <th>Type</th>
                <th>Address</th>
                <th>Order</th>
              </tr>
            </thead>
            <tbody>
              {locationHistory.map((entry) => {
                const locationType = getLocationType(entry);
                return (
                  <tr key={entry.id}>
                    <td className="date-cell">
                      {moment(entry.createdAt).format("MMM D, YYYY h:mm A")}
                    </td>
                    <td className="event-cell">
                      <span className={`event-badge event-${entry.eventType}`}>
                        {dumpsterEventTypeToText[entry.eventType]}
                      </span>
                    </td>
                    <td className="type-cell">
                      <span className={`type-badge type-${locationType}`}>
                        {locationTypeLabels[locationType]}
                      </span>
                    </td>
                    <td className="address-cell">
                      {formatAddress(entry.address, entry.city, entry.zip)}
                    </td>
                    <td className="order-cell">
                      {entry.orderId ? (
                        <Link to={`/orders/${entry.orderId}`} className="order-link">
                          View
                        </Link>
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
